/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { formResponsesState } from "./form-responses.state";

const formResponsesSlice = createSlice({
    
    name: "formResponses",

    initialState: formResponsesState,

    reducers: {

        setForm (state, action) {
            const payload = action.payload;
            const form = payload.form; // schema form
            const form_guid = payload.form_guid; // schema form
            state.form = form;
            state.form_guid = form_guid;
            state.responses = [];
            state.rows = [];
            state.filteredRows = [];
        },

        setFormResponses (state, action) {
            const payload = action.payload;
            const form_guid = payload.form_guid; // guid
            const responses = payload.responses;
            const current = payload.current;
            state.form_guid = form_guid;
            state.responses = responses;
            state.current = current;
        },

        setCurrentFormResponse (state, action) {
            const current = action.payload;
            state.current = current;
        },

        setRows (state, action) {
            const payload = action.payload;
            const rows = payload.rows;
            state.rows = rows;
        },
        
        setFilteredRows (state, action) {
            const payload = action.payload;
            const filteredRows = payload.filteredRows;
            state.filteredRows = filteredRows;
        },

        setSelectedQuestions (state, action) {
            const payload = action.payload;
            const selectedQuestions = payload.selectedQuestions;
            state.selectedQuestions = selectedQuestions;
        },

        setVizType (state, action) {
            state.vizType = action.payload;
        },

        removeFormResponses (state) {
            state.form = undefined;
            state.responses = undefined;
        },
    },
});

export const formResponsesReducer = formResponsesSlice.reducer;

export const {
    setForm,
    setFormResponses,
    setCurrentFormResponse,
    setVizType,
    removeFormResponses,
    setRows,
    setSelectedQuestions,
    setFilteredRows,
} = formResponsesSlice.actions;
